<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <b-tabs content-class="mt-3">
          <b-tab title="Details" active>
            <table class="table">
              <table-row label="Image" :noBorder="true">
                <v-lazy-image
                  v-if="part.image"
                  :src="part.image"
                  class="img-fluid maxHeight100"
                />
              </table-row>

              <table-row label="Code">
                {{ part.code }}
              </table-row>

              <table-row label="Description">
                {{ part.description }}
              </table-row>

              <table-row label="Barcode">
                {{ part.barcode }}
              </table-row>

              <table-row label="Type" v-if="part.part_type">
                {{ part.part_type.type }}
              </table-row>
              <table-row label="Bin Location" v-if="part.bin_location">
                <strong>{{ part.bin_location.code }}</strong
                ><br />
                {{ part.bin_location.description }}
              </table-row>

              <table-row label="ReOrder Level">
                {{ part.reorder_level }}
              </table-row>
              <table-row label="On Hand">
                {{ part.on_hand }}
              </table-row>
              <table-row label="On Order">
                {{ part.on_order }}
              </table-row>
              <table-row label="Sold">
                {{ part.sold }}
              </table-row>
              <table-row label="Purchased">
                {{ part.purchased }}
              </table-row>

              <table-row icon="lni-database" :noBorder="true" />

              <table-row label="Id">
                {{ part.id }}
              </table-row>

              <table-row label="Created">
                {{
                  moment(new Date(part.created_at)).format(
                    "DD MMM YYYY, HH:mm:ss"
                  )
                }}
              </table-row>
              <table-row label="Updated">
                {{
                  moment(new Date(part.updated_at)).format(
                    "DD MMM YYYY, HH:mm:ss"
                  )
                }}
              </table-row>
            </table>
          </b-tab>
          <b-tab title="Pricing">
            <table class="table">
              <table-row label="Current Cost" :noBorder="true">
                {{ part.current_cost }}
              </table-row>
              <table-row label="Average Cost">
                {{ part.average_cost }}
              </table-row>
              <table-row label="Last Cost">
                {{ part.last_cost }}
              </table-row>

              <table-row label="Selling Partner">
                {{ part.selling_price_partner }}
              </table-row>
              <table-row label="Selling Client">
                {{ part.selling_price_client }}
              </table-row>
            </table>
          </b-tab>
          <b-tab title="Running Balance">
            <div class="row mt-2" v-if="!loading">
              <div class="col">
                <div class="row">
                  <div class="col-md-4">
                    <label for="from">From</label>
                    <b-form-datepicker
                      id="from"
                      v-model="from"
                      class="mb-2"
                    ></b-form-datepicker>
                  </div>
                  <div class="col-md-4">
                    <label for="to">To</label>
                    <b-form-datepicker
                      id="to"
                      v-model="to"
                      class="mb-2"
                    ></b-form-datepicker>
                  </div>
                  <div class="col-md-4">
                    <small>Max 1 year range</small><br />
                    <button @click="getRunningBalance" class="btn btn-primary mt-2">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <table class="table table-bordered mt-3">
                  <thead>
                    <tr class="font-weight-bold bg-light">
                      <td>Date</td>
                      <td>Detail</td>
                      <td class="text-right">Debit</td>
                      <td class="text-right">Credit</td>
                      <td class="text-right">Balance</td>
                    </tr>

                    <tr v-for="item in runningBalances" :key="item.id">
                      <td>
                        {{
                          moment(new Date(item.created_at)).format(
                            "DD MMM YY, HH:mm"
                          )
                        }}
                      </td>

                      <td>
                        <span
                          v-if="
                            item.part_transaction
                              .part_transactionable_type == 'App\\JobPartRequisition'
                          "
                        >
                          #{{
                            item.part_transaction.part_transactionable
                              .job_part_requisition_number
                          }}
                          - Requisition
                        </span>
                        <span
                          v-if="
                            item.part_transaction
                              .part_transactionable_type == 'App\\JobPartReturn'
                          "
                        >
                          #{{
                            item.part_transaction.part_transactionable
                              .job_part_return_number
                          }}
                          - Return
                        </span>
                        <span
                          v-if="
                            item.part_transaction
                              .part_transactionable_type == 'App\\GoodsReceived'
                          "
                        >
                          #{{
                            item.part_transaction.part_transactionable
                              .goods_received_number
                          }}
                          - GRV [{{
                            item.part_transaction.part_transactionable
                              .reference
                          }}]
                        </span>
                        <span
                          v-if="
                            item.part_transaction
                              .part_transactionable_type ==
                            'App\\PartCredit'
                          "
                        >
                          #{{
                            item.part_transaction.part_transactionable
                              .part_credit_number
                          }}
                          - Credit [{{
                            item.part_transaction.part_transactionable
                              .reference
                          }}]
                        </span>
                        <span
                          v-if="
                            item.part_transaction
                              .part_transactionable_type ==
                            'App\\PartDebit'
                          "
                        >
                          #{{
                            item.part_transaction.part_transactionable
                              .part_debit_number
                          }}
                          - Debit [{{
                            item.part_transaction.part_transactionable
                              .reference
                          }}]
                        </span>

                        <span
                          v-if="
                            item.part_transaction
                              .part_transactionable_type == 'App\\Invoice'
                          "
                        >
                          #{{
                            item.part_transaction.part_transactionable
                              .invoice_number
                          }}
                          - Invoice 
                        </span>
                      </td>
                      <td class="font-italic text-right">
                        <span v-if="item.debit">{{ item.debit }}</span>
                      </td>
                      <td class="font-italic text-right">
                        <span v-if="item.credit">{{ item.credit }}</span>
                      </td>
                      <td class="font-weight-bold text-right">
                        {{ item.balance }}
                      </td>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import partRepo from "@/api/repos/partRepo";
import tableRow from "@/components/common/TableRow";

export default {
  props: ["id"],

  components: {
    tableRow,
  },
  mounted() {
    this.getPart();
    this.getRunningBalance();
  },

  data() {
    return {
      runningBalances: [],
      loading: false,
      part: {},
      from: this.moment().subtract(3, "months").format("YYYY-MM-DD"),
      to: this.moment().format("YYYY-MM-DD"),
    };
  },

  methods: {
    async getPart() {
      try {
        this.loading = true;
        let { data } = await partRepo.get(this.id);
        this.part = data.part;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async getRunningBalance() {
      //from is not greate
      if (this.moment(this.from).isAfter(this.moment(this.to))) {
        this.$root.$bvToast.toast("From can not be after to", {
          title: "Invalid Range",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return;
      }

      //not more then a year
      if (this.moment(this.to).diff(this.moment(this.from), "days") > 366) {
        this.$root.$bvToast.toast("Range can not be greater than 1 year", {
          title: "Invalid Range",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return;
      }

      this.isLoad = true;
      try {
        let { data } = await partRepo.partRunningBalance(
          this.id,
          this.from,
          this.to
        );

        this.runningBalances = data.running_balances;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
